import { Seo, faqJsonLd } from "@/components/Seo";
import { CtaBand } from "@/components/Shared";
import { UI, PATHS } from "@/i18n/ui";
import { ORG_JSONLD } from "@/data/site";
import { FAQ } from "@/data/faq";
import {
  HeroSection, TrustBar, ServicesGrid, TopicsSection, WhySection,
  HowSection, TeamSection, TestimonialsSection, FaqPreview, LocationStrip,
} from "@/pages/home-sections";

const META = {
  id: {
    title: "Psikolog & Konseling di Denpasar, Bali | Bali Empower",
    desc: "Layanan psikolog, konseling, asesmen psikologi dan program kesehatan mental profesional di Denpasar, Bali. Dapatkan dukungan yang sesuai dengan kebutuhan Anda.",
  },
  en: {
    title: "Psychologist & Counseling Services in Denpasar, Bali | Bali Empower",
    desc: "Professional psychological counseling, psychological assessment and mental health services in Denpasar, Bali. Find personalized support for yourself, your relationship or your family.",
  },
};

export default function Home({ lang }) {
  const t = UI[lang];
  const p = PATHS[lang];
  const faqItems = FAQ.slice(0, 5).map((f) => [f.q[lang], f.a[lang]]);

  return (
    <div data-testid="home-page">
      <Seo title={META[lang].title} description={META[lang].desc} lang={lang}
        jsonLd={[ORG_JSONLD, faqJsonLd(faqItems)]} />
      <HeroSection lang={lang} t={t} p={p} />
      <TrustBar t={t} />
      <ServicesGrid lang={lang} t={t} p={p} />
      <TopicsSection lang={lang} t={t} p={p} />
      <WhySection t={t} />
      <HowSection lang={lang} t={t} p={p} />
      <TeamSection lang={lang} t={t} p={p} />
      <TestimonialsSection lang={lang} />
      <FaqPreview t={t} p={p} faqItems={faqItems} />
      <LocationStrip t={t} p={p} />
      <CtaBand lang={lang} />
    </div>
  );
}
